import {
  useCompleteOrgMaintenanceTaskMutation,
  useDeleteOrgMaintenanceTaskMutation,
  useGetMaintenanceTasksQuery,
  useGetOrgMaintenanceTasksQuery,
} from "../../../graphql/generated";
import OrgMaintenanceTasksList, {
  OrgMaintenanceTaskListProps,
} from "./OrgMaintenanceTasksList";

type MaintenanceTasksListContainerProps = Omit<
  OrgMaintenanceTaskListProps,
  "query" | "deleteMutation" | "onRefresh" | "onComplete"
>;

export default function OrgMaintenanceTasksListContainer(
  props: MaintenanceTasksListContainerProps
) {
  // const bulkCreateMaintenanceTasks = useBulkAddMaintenanceTasksMutation();
  let refetch = () => {};
  // I need a handle on refetch so I can call it
  // a new settlement has been generated
  const useGetOrgMaintenanceTaskListQueryCustom: typeof useGetOrgMaintenanceTasksQuery =
    (variables, options) => {
      const query = useGetOrgMaintenanceTasksQuery(
        { ...variables },
        {
          ...options,
        }
      );
      refetch = query.refetch;
      return query;
    };
  useGetOrgMaintenanceTaskListQueryCustom.fetcher =
    useGetOrgMaintenanceTasksQuery.fetcher;
  useGetOrgMaintenanceTaskListQueryCustom.getKey =
    useGetMaintenanceTasksQuery.getKey;

  const completeOrgMaintenanceTaskMutation =
    useCompleteOrgMaintenanceTaskMutation();

  return (
    <OrgMaintenanceTasksList
      query={useGetOrgMaintenanceTaskListQueryCustom}
      deleteMutation={useDeleteOrgMaintenanceTaskMutation}
      onRefresh={() => {
        refetch();
      }}
      onComplete={async (task) => {
        try {
          await completeOrgMaintenanceTaskMutation.mutateAsync({
            id: task._id,
          });
          refetch();
        } catch (error) {
          console.error(error);
        }
      }}
      {...props}
    />
  );
}
